module.exports = __webpack_public_path__ + "static/media/price.51f4f6d4.svg";